let id = 0;
/**
 * @return {number} A unique ID (not universally unique)
 */
export default () => ++id;
